function DirectorySearchBarWrapper({ children }) {
  return (
    <div className="flex flex-row flex-wrap items-start lg:flex-row px-1">
      {children}
    </div>
  );
}

export default DirectorySearchBarWrapper;
